/**
 * @module components\Shared\MobileNavigation
 */
import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";

@Component
export default class MobileNavigation extends Vue {
  mobNav = false;
  items = [
    { title: "Home", icon: "dashboard" },
    { title: "About", icon: "question_answer" }
  ];
}
